const CLIENT_IP_PORT_RESPONSE_HEADER_NAME = 'x-client-info';

export const initialState = {
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'LOGOUT': {
            const { headers, newCookies, ...newState } = state; // eslint-disable-line no-unused-vars

            return newState;
        }
        case 'SET_COOKIES': {
            let cookies = {};

            if (state.headers && state.headers.cookie) {
                const cookiesArray = state.headers.cookie.split(';');

                cookiesArray.forEach(
                    cookieString => {
                        const cookieValues = cookieString.split('=');

                        if (cookieValues[0] && cookieValues[1]) {
                            cookies[cookieValues[0].trim()] = {
                                name: cookieValues[0].trim(),
                                value: cookieValues[1].trim()
                            };
                        }
                    }
                );
            }
            cookies = { ...cookies, ...action.cookies };

            let newCookie = '';

            Object.keys(cookies).forEach(key => {
                newCookie = `${newCookie}${cookies[key].name}=${cookies[key].value};`;
            });
            return {
                ...state,
                headers: {
                    ...state.headers,
                    cookie: newCookie
                },
                newCookies: {
                    ...state.newCookies,
                    ...action.cookies
                }
            };
        }
        case 'SET_REQUESTS_CONFIG':
            return {
                ...state,
                cookiesObject: action.config.cookies,
                headers: action.config.headers,
                sessionFeatures: action.config.sessionFeatures
            };
        case 'CLEAR_HEADERS': {
            const { headers, newCookies, cookiesObject, ...newState } = state; // eslint-disable-line no-unused-vars

            return newState;
        }
        case 'SET_QUERY_PARAM': {
            return {
                ...state,
                queryParam: action.queryParam
            };
        }
        case 'SET_LANG_ONBOARD_FLAG': {
            return {
                ...state,
                queryParam: {
                    ...state.queryParam,
                    showLanguageOnboarding: action.showLanguageOnboarding
                }
            };
        }
        case 'SET_CLIENT_IP_PORT': {
            const headers = action.responseHeaders;
            const clientIpPortHeader = headers?._headers?.[CLIENT_IP_PORT_RESPONSE_HEADER_NAME] || headers?.map?.[CLIENT_IP_PORT_RESPONSE_HEADER_NAME] || [];
            const clientIpPort = clientIpPortHeader.length && clientIpPortHeader[0] || state.clientIpPort || '';

            return {
                ...state,
                clientIpPort
            };
        }
        default:
            return state;
    }
};
